function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { useBuildStyleWithTheme } from "../../ThemeProvider/useBuildStyleWithTheme";
function buildStyle(param, param1) {
    var backgroundColor = param.backgroundColor, borderColor = param.borderColor, font = param.font, size = param.size, end = param1.end, start = param1.start;
    var _obj;
    return {
        button: (_obj = {
            boxSizing: 'border-box',
            backgroundColor: 'transparent',
            borderRadius: size.border.radius.threeX,
            marginTop: 0,
            marginBottom: 0
        }, _defineProperty(_obj, start.margin, 8), _defineProperty(_obj, end.margin, 8), _defineProperty(_obj, "padding", 0), _defineProperty(_obj, "width", 40), _defineProperty(_obj, "height", 40), _defineProperty(_obj, "color", font.color.fill), _defineProperty(_obj, '&:hover', {
            backgroundColor: backgroundColor.click.hover
        }), _defineProperty(_obj, '&:active', {
            backgroundColor: backgroundColor.click.active
        }), _defineProperty(_obj, '&:disabled', {
            color: backgroundColor.active,
            cursor: 'default',
            svg: {
                fill: backgroundColor.active
            },
            '&:hover': {
                background: 'transparent',
                color: backgroundColor.active
            }
        }), _defineProperty(_obj, '&:focus-visible', {
            outline: 0,
            boxShadow: "0 0 0 ".concat(size.border.focus, "px ").concat(borderColor.neutral.fill.focus)
        }), _obj),
        icon: {
            color: font.color.fill,
            size: 'm',
            '&:hover': {
                color: font.color.hover
            },
            '&:active': {
                color: font.color.active
            }
        },
        pill: {
            borderRadius: size.border.radius.round
        }
    };
}
export default function useStyle(isPill) {
    var builtStyle = useBuildStyleWithTheme(buildStyle);
    if (!builtStyle) {
        return {
            buttonStyle: {},
            iconStyle: {}
        };
    }
    var button = builtStyle.button, pill = builtStyle.pill, icon = builtStyle.icon;
    return {
        buttonStyle: _objectSpread({}, button, isPill ? pill : {}),
        iconStyle: _objectSpread({}, icon)
    };
};
